/* @flow */
import React from 'react';
import AccountLinkingComposerSidebarContent from './AccountLinkingComposerSidebarContent';
import AccountLinkingComposerSidebarServices from './AccountLinkingComposerSidebarServices';
import AccountLinkingComposerSidebarServicesContainer from '../containers/AccountLinkingComposerSidebarServicesContainer';

type Props = {
  fetchPolicy?: string,
  addLinkedContent: (*) => void,
};

type State = {
  viewingSource: ?*,
};

class AccountLinkingComposerSidebar extends React.Component<Props, State> {
  state: State = {
    viewingSource: null,
  };

  viewContent = (contentSource: *) => {
    this.setState({
      viewingSource: contentSource,
    });
  };

  viewSources = (reloadData: boolean, refetchCallback: Function) => {
    if (reloadData) {
      refetchCallback();
    }

    this.setState({
      viewingSource: null,
    });
  };

  render() {
    const { addLinkedContent } = this.props;
    const { viewingSource } = this.state;

    return (
      <AccountLinkingComposerSidebarServicesContainer fetchPolicy={this.props.fetchPolicy}>
        {({ loading, sources, error, refetch }) => {
          if (viewingSource == null) {
            return (
              <AccountLinkingComposerSidebarServices
                error={error}
                sources={sources}
                loading={loading}
                onViewContent={this.viewContent}
                reloadContentSources={refetch}
              />
            );
          } else {
            return (
              <AccountLinkingComposerSidebarContent
                onViewSources={(reloadData: boolean) => this.viewSources(reloadData, refetch)}
                addLinkedContent={addLinkedContent}
                contentSource={viewingSource}
              />
            );
          }
        }}
      </AccountLinkingComposerSidebarServicesContainer>
    );
  }
}

export default AccountLinkingComposerSidebar;
